module.exports = __webpack_public_path__ + "static/worldline-large-21537ddc0ff21e7bd5b9e2cb7b239f56.png";